import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import DayJs from 'utils/Dayjs';

import Pill from 'components/Misc/Pill';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

const Webinars = () => {
	// Cache current object's id
	const { id } = useParams();

	// Store request parameters
	const parameters = useMemo(() => ({
		courseId: id,
		eager: 'subject',
		orderBy: 'eventAt',
		type: 'online'
		// 'eventAt:gte': DayJs().add(3, 'hour'),
	}), []);

	// Store requested course
	const [[webinars], collect] = useCollect('webinars', parameters);

	// Collect course on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Do not display anything if there are no webinars
	if (!webinars?.length) return null;

	return (
		<Container className="p-4 flex flex-col gap-4">
			{webinars?.map(webinar =>
				<div key={webinar.id} className="flex items-center space-x-2">
					<div className="flex-1 overflow-hidden space-y-2">
						<Title
							title={webinar.title}
							subtitle={webinar.subject.title}
							className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
						/>

						<Pill
							theme="informative"
							name={DayJs(webinar.eventAt).format('D. MMM, YYYY - HH:mm')}
						/>
					</div>

					<Button
						small
						square
						icon="link"
						to={`/webinars/${webinar.id}`}
					/>
				</div>
			)}
		</Container>
	);
};

export default Webinars;